import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { HttpClientModule } from '@angular/common/http';
import { CustomerdetailComponent } from './customer/customerdetail/customerdetail.component';
import { CustomerListComponent } from './customer/customer-list/customer-list.component';
import { CouponListComponent } from './coupon/coupon-list/coupon-list.component';
import { AddCouponsComponent } from './coupon/add-coupons/add-coupons.component';
import { EditAccountComponent } from './account/edit-account/edit-account.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { VendorTransactionDetailsComponent } from './vendor-finance/transaction-details/transaction-details.component';
import { VendorTransactionListComponent } from './vendor-finance/transaction-list/transaction-list.component';
import { AccountloginComponentComponent } from './accountlogin-component/accountlogin-component.component'
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ValidatepasswordComponent } from './validatepassword/validatepassword.component';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    CustomerdetailComponent,
    CustomerListComponent,
    CouponListComponent,
    AddCouponsComponent,
    EditAccountComponent,
    ForgetpasswordComponent,
    ResetpasswordComponent,
    VendorTransactionDetailsComponent,
    VendorTransactionListComponent,
    AccountloginComponentComponent,
    ValidatepasswordComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
